import React, { useId } from 'react';

import { ORIGIN_TAG_API } from '~support-at-home/lib/serviceOrigin';

import { TooltipIcon } from '~components';
import { faLock, faPencil } from '~components/icon';

interface RowLike {
  id?: string | number;
  origin_tag?: string;
  [key: string]: unknown;
}

interface ComponentProps {
  row?: RowLike;
}

// TAV-3420 source indicator. A lock marks a service imported from Services Australia (read-only
// here), a pencil marks one entered by hand. Modelled on PaymentSourceBadge.
const ServiceSourceBadge: React.FC<ComponentProps> = ({ row }) => {
  // Per-instance fallback so two badges without a row id do not share a tooltip anchor.
  const fallbackId = useId();
  const tooltipId = row?.id !== undefined ? String(row.id) : fallbackId;

  if (row?.origin_tag === ORIGIN_TAG_API) {
    return (
      <TooltipIcon
        id={`service-source-${tooltipId}`}
        icon={faLock}
        tooltip="Imported from Services Australia. Cannot be edited here."
        iconColor="dodgerblue"
      />
    );
  }

  return <TooltipIcon id={`service-source-${tooltipId}`} icon={faPencil} tooltip="Entered by hand" iconColor="gray" />;
};

export default ServiceSourceBadge;
